import { render, staticRenderFns } from "./LineWrapper.vue?vue&type=template&id=0a0638c4&scoped=true"
import script from "./LineWrapper.vue?vue&type=script&lang=js"
export * from "./LineWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0638c4",
  null
  
)

export default component.exports